export default __webpack_public_path__ + "static/media/prologue-tv.a8059cbc.png";